import React from 'react';
import { Stars } from '../Stars';
import { SectionHeading } from '../SectionHeading';
import { heroTestimonials } from '../../data/landing';
export function Testimonials() {
  return <section className="bg-brand-soft px-5 py-16 md:py-24" aria-labelledby="testimonios" data-id="element-240" data-mp="3mh2bjwf1lign">
      <div className="mx-auto max-w-6xl" data-id="element-241" data-mp="3r7intd74my1f">
        <div id="testimonios" data-id="element-242" data-mp="3r8kakexi98yz">
          <SectionHeading eyebrow="Testimonios" title="Ellos ya comen sin miedo." data-id="element-243" data-mp="3r8tvho3p0pxt" />
        </div>
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-244" data-mp="y4kfnbcuey">
          {heroTestimonials.map(t => <figure key={t.author} className="flex flex-col rounded-3xl bg-white p-7 shadow-sm" data-id="element-245" data-mp="4188znvgjcrp">
              <div className="flex items-center gap-3" data-id="element-246" data-mp="92fgrmxlobyd">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand text-base font-black text-white" data-id="element-247" data-mp="e1ilt7dkyi6c">
                  {t.initials}
                </span>
                <Stars data-id="element-248" data-mp="2fsc3c074p9gz" />
              </div>
              <blockquote className="mt-5 text-lg font-medium leading-relaxed text-charcoal" data-id="element-249" data-mp="2ft548kjep4r7">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-6 text-sm font-bold text-brand" data-id="element-250" data-mp="1ntsxywph0sp7">
                — {t.author}, <span className="font-medium text-muted" data-id="element-251" data-mp="1iuprr8xr8gfn">{t.meta}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}